(function ( $ ) {

	$.fn.tiledgallery = function () {
		var $elem = $( this ),
			$tiles = $elem.find( '.tiled-gallery__item--trigger' ).not( '.tiled-gallery__item--load-next' ),
			$tileLoadNext = $elem.find( '.tiled-gallery__item--load-next' ),
			baseWidth = $tiles.eq( 0 ).outerWidth() - 1,
			baseHeight = $tiles.eq( 0 ).outerHeight() - 1,
			numLayouts = 3,
			$grid,
			uniqueSlideCounter = 0,

			ajaxCurrPaginatedPage = 1,
			ajaxImagesPerRequest = 14,
			ajaxMorePagesLeft = true,

			photoswipeContainerInjected = false,
			$photoswipeContainer,
			photoswipeInstance,
			arrPhotoswipeItems = [],
			slideYtPlayerInstance,

			$currPhotoswipeItem,
			$currentSlidePlayer;
		;

		var init = function () {
				if ( $tiles.length < 1 ) {
					return;
				}


				if ( !$elem.hasClass( 'tiled-gallery--event' ) ) {
					adjustTilesMarkup( $tiles.add( $tileLoadNext ) );
				}
							
				addPhotoSwipeModalMarkup();
				addPhotoswipeElements( $tiles );
				bindEvents();


			},
			bindEvents = function () {

				// Not using for event-single galleries
				if ( !$elem.hasClass( 'tiled-gallery--event' ) ) {
					$tileLoadNext.on( 'click', function ( e ) {
						e.preventDefault();

						var $clicked = $( this ),
							alreadyLoading = $clicked.hasClass( 'ajax-loading' );

						// Disable clicking non-stop if we're already in the process of loading more
						if ( alreadyLoading || ajaxMorePagesLeft == false ) {
							return false;
						}

						$clicked.addClass( 'ajax-loading' );

						ajaxLoadMore();

					} );
				}

				bindPhotoSwipeClick();

			},
			bindPhotoSwipeClick = function () {
				$elem.on( 'click.photoswipeclick', '.tiled-gallery__item--trigger', function ( e ) {
					e.preventDefault();

					if ( $( e.target ).hasClass( 'tiled-gallery__item--load-next' ) ) {
						return true;
					}


					var $this = $( this ),
						currIndex = $tiles.index( $this );


					var options = {
						index   : currIndex, // start at first slide
						history : false
					};

					photoswipeInstance = new PhotoSwipe( $photoswipeContainer[ 0 ], PhotoSwipeUI_Default, arrPhotoswipeItems, options );
					photoswipeInstance.init();


					photoswipeInstance.listen( 'gettingData', function () {
						photoswipeDetectVideo( photoswipeInstance );
					} );


					photoswipeInstance.listen( 'beforeChange', function () {
						removeVideo();
					} );

					photoswipeInstance.listen( 'close', function () {
						removeVideo();
					} );


					photoswipeInstance.listen( 'resize', function () {
						if ( $currentSlidePlayer ) {
							makeSureVideoFits( $currentSlidePlayer.parent() );
						}
					} );
				} );
			},
			adjustTilesMarkup = function ( $arrElements ) {


				$arrElements.each( function ( i, el ) {

					var $this = $( this ),
						videoId = $this.data( 'youtube-id' );

					// Starting the tile classes at 1
					$this.addClass( 'tiled-gallery__item--tile-' + ( i + 1 ) );

					// Uncomment if you want to see "counters" within the blocks for debugging
					// $this.append( '<div style="position: absolute; color: white; top: 40px; left: 0; width: 100%; text-align: center; font-size: 30px; 	text-shadow: 2px 2px #ff0000;">' + ( i + 1 ) + '</div>' );

					if ( videoId ) {
						$this.addClass( 'tiled-gallery__item--video' )
					}
				} );

				var currLayout = ( ajaxCurrPaginatedPage - 1 ) % numLayouts + 1,
					$wrapper = $arrElements.wrapAll( '<div class="tiled-gallery__tile-group" />' )
						.parent()
						.addClass( 'tiled-gallery__tile-group--layout-' + currLayout );


			},
			ajaxLoadMore = function () {

				if ( typeof CAFvars == 'undefined' || typeof CAFvars.ajax_url == 'undefined' ) {
					console.error( '[CAF:tiledgallery] Please declare a JS variable with wp_localize_script() to access the AJAX tiled gallery "load more".' );
					return;
				}

				var desiredPage = ajaxCurrPaginatedPage + 1;

				$.ajax( {
					url      : CAFvars.ajax_url,
					dataType : 'json',
					data     : {
						action         : 'tiled_gallery_load_more',
						requested_page : desiredPage
					}
				} ).always( function ( data ) {

					if ( typeof data.success == 'undefined' || data.success != true ) {
						console.error( 'Something went wrong trying to fetch new Images for the Tiled Gallery' );
						return;
					}


					if ( data.last_page == true ) {
						ajaxMorePagesLeft = false;
						$tileLoadNext.addClass( 'inactive' );
					}


					ajaxCurrPaginatedPage++;

					if ( data.images.length > 0 ) {
						appendNewTiles( data.images );

						$tileLoadNext.removeClass( 'ajax-loading' );
					}


				} );
			},
			appendNewTiles = function ( arrImages ) {

				// Last-minute check
				if ( typeof arrImages == 'undefined' || Object.prototype.toString.call( arrImages ) !== '[object Array]' ) {
					return false;
				}

				var $addedTiles = $(),
					$loadNextReplacer = $( templateHtmlTiles( arrImages[ 0 ] ) ),
					$addedFirstTile = $loadNextReplacer.insertBefore( $tileLoadNext );

				$addedFirstTile.addClass( 'tiled-gallery__item--tile-14' );

				// Starting with second tile
				for ( var i = 1; i < arrImages.length; i++ ) {
					var $newItem = $( templateHtmlTiles( arrImages[ i ] ) ).appendTo( $elem );

					$addedTiles = $addedTiles.add( $newItem );

				}


				$tiles = $tiles.add( $addedFirstTile ).add( $addedTiles );

				adjustTilesMarkup( $addedTiles );
				addPhotoswipeElements( $addedFirstTile.add( $addedTiles ) );

				$tileLoadNext.insertAfter( $tiles.last() );
			},
			templateHtmlTiles = function ( singleImageData ) {
				// Should match the same as the initital loop / template

				var htmlOut = '',
					videoClass = '',
					videoDataAttribute = '',
					caption = '';

				if ( typeof singleImageData.video_id != 'undefined' && singleImageData.video_id != '' ) {
					videoDataAttribute = ' data-youtube-id="' + singleImageData.video_id + '" ';
					videoClass = ' tiled-gallery__item--video ';
					console.log( 'Found a video', videoDataAttribute );
				}

				if ( typeof singleImageData.caption != 'undefined' && singleImageData.caption != '' ) {
					caption = singleImageData.caption;
				}

				htmlOut += '<a href="' + singleImageData.full_size + '" class="tiled-gallery__item' + videoClass + '" style="background-image: url(\'' + singleImageData.thumbnail + '\');" ';

				htmlOut += ' data-image-thumb="' + singleImageData.thumbnail + '" ';
				htmlOut += ' data-image-full="' + singleImageData.full_size + '" ';

				htmlOut += ' data-image-full-width="' + singleImageData.image_full_width + '" ';
				htmlOut += ' data-image-full-height="' + singleImageData.image_full_height + '" ';

				htmlOut += videoDataAttribute;
				htmlOut += ' >'; // closing of opening tag
				htmlOut += '<div class="tiled-gallery__caption">' + caption + '</div>';
				htmlOut += '</a>';

				return $( htmlOut );
			},


			addPhotoswipeElements = function ( $arrElements ) {


				$arrElements.each( function ( i, el ) {

					var $this = $( this ),
						dataImageThumb = $this.data( 'image-thumb' ),
						dataImageFull = $this.data( 'image-full' ),
						dataImageFullWidth = parseInt( $this.data( 'image-full-width' ), 10 ),
						dataImageFullHeight = parseInt( $this.data( 'image-full-height' ), 10 ),
						videoId = $this.data( 'youtube-id' ),
						isVideo = videoId ? true : false,
						$caption = $this.find( '.tiled-gallery__caption' ),
						captionText = '';

					if ( $caption.length > 0 ) {
						captionText = $caption.html();
						captionText = captionText.trim();
					}


					if ( isVideo && videoId ) {
						var newItem = {
							html    : '<div class="video-container-container" data-youtube-id="' + videoId + '" data-slide-id="' + uniqueSlideCounter + '"></div>',
							isVideo : isVideo,
							videoId : videoId,
							slideId : uniqueSlideCounter

						};
					} else {

						var newItem = {
							src     : dataImageFull,
							w       : dataImageFullWidth,
							h       : dataImageFullHeight,
							isVideo : isVideo,
							slideId : uniqueSlideCounter
						};
					}

					if ( typeof captionText != 'undefined' && captionText != '' ) {
						newItem.title = captionText;
					}


					uniqueSlideCounter++;
					arrPhotoswipeItems.push( newItem );
				} );

			},

		// Photoswipe markup taken from http://photoswipe.com/documentation/getting-started.html
			addPhotoSwipeModalMarkup = function () {

				if ( photoswipeContainerInjected == false ) {
					var photoswipeModalContent = '';
					photoswipeModalContent += '<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">';
					photoswipeModalContent += '    <div class="pswp__bg"></div>';
					photoswipeModalContent += '    <div class="pswp__scroll-wrap">';
					photoswipeModalContent += '        <div class="pswp__container">';
					photoswipeModalContent += '            <div class="pswp__item"></div>';
					photoswipeModalContent += '            <div class="pswp__item current"></div>';
					photoswipeModalContent += '            <div class="pswp__item"></div>';
					photoswipeModalContent += '        </div>';
					photoswipeModalContent += '        <div class="pswp__ui pswp__ui--hidden">';
					photoswipeModalContent += '            <div class="pswp__top-bar">';
					photoswipeModalContent += '                <div class="pswp__counter"></div>';
					photoswipeModalContent += '                <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>';
					photoswipeModalContent += '                <button class="pswp__button pswp__button--share" title="Share"></button>';
					photoswipeModalContent += '                <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>';
					photoswipeModalContent += '                <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>';
					photoswipeModalContent += '                <div class="pswp__preloader">';
					photoswipeModalContent += '                    <div class="pswp__preloader__icn">';
					photoswipeModalContent += '                      <div class="pswp__preloader__cut">';
					photoswipeModalContent += '                        <div class="pswp__preloader__donut"></div>';
					photoswipeModalContent += '                      </div>';
					photoswipeModalContent += '                    </div>';
					photoswipeModalContent += '                </div>';
					photoswipeModalContent += '            </div>';
					photoswipeModalContent += '            <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">';
					photoswipeModalContent += '                <div class="pswp__share-tooltip"></div> ';
					photoswipeModalContent += '            </div>';
					photoswipeModalContent += '            <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">';
					photoswipeModalContent += '            </button>';
					photoswipeModalContent += '            <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">';
					photoswipeModalContent += '            </button>';
					photoswipeModalContent += '            <div class="pswp__caption">';
					photoswipeModalContent += '                <div class="pswp__caption__center"></div>';
					photoswipeModalContent += '            </div>';
					photoswipeModalContent += '        </div>';
					photoswipeModalContent += '    </div>';
					photoswipeModalContent += '</div>';

					$photoswipeContainer = $( photoswipeModalContent ).appendTo( $( 'body' ) );
					photoswipeContainerInjected = true;
				}
			},
			makeSureVideoFits = function ( $element ) {

				var $win = $( window ),
				//winHeight = $win.height(),
					winHeight = $element.parents( '.pswp__zoom-wrap' ).innerHeight(),
				// winWidth = $win.width(),
					winWidth = $element.parents( '.pswp__zoom-wrap' ).innerWidth(),
					vidRatio = 16 / 9,
					vidWidthCalRatio = 9 / 16,
					safetyRatio = 0.9,
					maxHeight = winWidth / vidRatio * safetyRatio,
					calcWidth = Math.floor( ( winHeight * safetyRatio) * vidRatio ),
					doesItFit = maxHeight < winHeight;

				if ( calcWidth > winWidth ) {
					var outerWidth = Math.floor( winWidth * safetyRatio ),
						outerHeight = outerWidth / 16 * 9;
					$element
						.outerWidth( outerWidth )
						.outerHeight( outerHeight )
						.css( {
							position : 'absolute',
							top      : ( winHeight - outerHeight ) / 2,
							left     : ( winWidth - outerWidth ) / 2
						} );


				} else if ( !doesItFit ) {
					var outerWidth = calcWidth,
						outerHeight = calcWidth / 16 * 9;

					$element
						.outerWidth( calcWidth )
						.outerHeight( outerHeight )
						.css( {
							position : 'absolute',
							top      : ( winHeight - outerHeight ) / 2,
							left     : ( winWidth - outerWidth ) / 2
						} );
				} else {
					var outerWidth = Math.floor( winWidth * safetyRatio ),
						outerHeight = calcWidth / 16 * 9;
					$element
						.outerWidth( outerWidth )
						.outerHeight( outerHeight )
						.css( {
							position : 'absolute',
							top      : ( winHeight - outerHeight ) / 2,
							left     : ( winWidth - outerWidth ) / 2
						} );
				}


				$element.css( {
					paddingBottom : 0
				} );


				console.log( $element, calcWidth, doesItFit, $element.parents( '.pswp__zoom-wrap' ), $element.parents( '.pswp__zoom-wrap' ).innerWidth() );

			},

			photoswipeDetectVideo = function ( photoswipeInstance ) {
				var currItem = photoswipeInstance.currItem;

				if ( typeof currItem.isVideo != 'undefined' && true == currItem.isVideo && typeof currItem.videoId != 'undefined' && '' != currItem.videoId ) {
					$currPhotoswipeItem = $photoswipeContainer.find( '[data-slide-id="' + currItem.slideId + '"]' );
					console.log( $photoswipeContainer, $currPhotoswipeItem, currItem.slideId );
					loadYtJs( currItem.videoId );
				}

			},
			loadYtJs = function ( videoId ) {
				if ( typeof CAF == 'undefined' ) {
					CAF = {};
				}

				if ( typeof CAF.youtubeJsLoaded == 'undefined' || CAF.youtubeJsLoaded != true ) {
					var tag = document.createElement( 'script' );

					tag.src = "//www.youtube.com/iframe_api";
					var firstScriptTag = document.getElementsByTagName( 'script' )[ 0 ];
					firstScriptTag.parentNode.insertBefore( tag, firstScriptTag );

					if ( typeof window.onYouTubeIframeAPIReady == 'undefined' ) {
						window.onYouTubeIframeAPIReady = function () {
							CAF.youtubeJsLoaded = true;

							setupAndPlayVideo( videoId );
						}
					}

				} else {
					setupAndPlayVideo( videoId );
				}
			},
			setupAndPlayVideo = function ( videoId ) {

				var idUniqueness = Date.now() / 1000 | 0,
					idToUse = 'slide-yt-frame--' + idUniqueness;


				$currentSlidePlayer = $( '<div id="' + idToUse + '" />' ).appendTo( $currPhotoswipeItem );


				if ( typeof CAF.players == 'undefined' ) {
					CAF.players = {};
				}


				// ref: https://developers.google.com/youtube/player_parameters
				CAF.players[ idToUse ] = new YT.Player(
					idToUse, {
						videoId    : videoId,
						playerVars : {
							autohide       : 2,
							autoplay       : 0,
							controls       : 1,
							loop           : 0,
							modestbranding : 1,
							rel            : 0,
							showinfo       : 1,
						},
						events     : {
							'onReady' : playVideo
						}
					} );


				makeSureVideoFits( $currentSlidePlayer.parent() );
			},
			playVideo = function ( event ) {

				// Mute if sound option = mute
				if ( typeof CAF != 'undefined' && typeof CAF.OPTIONS != 'undefined' && typeof CAF.OPTIONS.soundOn != 'undefined' && CAF.OPTIONS.soundOn == false ) {
					event.target.setVolume( 0 );
				}

				slideYtPlayerInstance = event.target;
				event.target.playVideo();

			},
			removeVideo = function () {

				console.log( $photoswipeContainer.find( '.video-container-container' ) );

				if ( slideYtPlayerInstance ) {
					try {
						slideYtPlayerInstance.stopVideo();
					}
					catch ( e ) {

					}

					slideYtPlayerInstance = null;
					$currentSlidePlayer = null;
				}

				$photoswipeContainer.find( '.video-container-container' ).find( 'iframe' ).remove();

			};

		init();
		return this;
	};

}( $ ));